import { render, staticRenderFns } from "./MttoBIomedicaModalInsumos.vue?vue&type=template&id=03276432&"
import script from "./MttoBIomedicaModalInsumos.vue?vue&type=script&lang=js&"
export * from "./MttoBIomedicaModalInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports